import { render, staticRenderFns } from "./TaskDesigner.vue?vue&type=template&id=50f8e6c8&scoped=true"
import script from "./TaskDesigner.vue?vue&type=script&lang=js"
export * from "./TaskDesigner.vue?vue&type=script&lang=js"
import style0 from "./TaskDesigner.vue?vue&type=style&index=0&id=50f8e6c8&prod&lang=less"
import style1 from "./TaskDesigner.vue?vue&type=style&index=1&id=50f8e6c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f8e6c8",
  null
  
)

export default component.exports